var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c('v-btn',_vm._g({attrs:{"icon":""},on:{"click":_vm.toggleInsightsDrawer}},on),[_c('v-icon',{domProps:{"textContent":_vm._s('$insights')}})],1)]}}])},[_c('span',{staticClass:"text-center"},[_vm._v(" "+_vm._s(_vm.$t('modules.insights'))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }